<template>
  <div>
    <div class="cake-layout">
      <router-view></router-view>
    </div>
    <!-- <layoutTabbar :tab-list="tabList"></layoutTabbar> -->
  </div>
</template>
<script>
import routeMap from '@/router/routes/cakeMap.js'
import Axios from 'axios'
// import layoutTabbar from '@/components/Tabbar.vue'

export default {
  components: {
    // layoutTabbar
  },
  data() {
    return {
    }
  },
  computed: {
    tabList () {
      const list = routeMap[0].children.map(item => {
        return {
          name: item.meta.name,
          path: item.path,
          icon: {
            active: item.icon.active,
            inactive: item.icon.inactive
          }
        }
      })
      
      return [
      {
        name: '商城首页',
        path: '/tabbar/home',
        icon: {
          active: '',
          inactive: ''
        }
      }, ...list]
    }
  }
}
</script>
<style lang="scss" scoped>
  .cake-layout{
    // padding-bottom: 1rem;
    background: $cake-primary-bg;
    min-height: calc(100vh - 1rem);
  }
</style>